<template>
    <div class="small-player-scores-row">
        <div :class="['player-score-item', current.id == player.id ? 'active' : '']" v-for="player in players" :key="player.id">
            <div class="playername">{{player.name}}</div>
            <div class="score">{{player.score}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'players',
            'current'
        ],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>


<style scoped>

</style>

